import BaseForm from '../base';
export class CamerasPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: []
};
